import { InjectionToken } from '@angular/core';
import { IUtmConfig } from '../interface';

export const UTM_CONFIG = new InjectionToken<IUtmConfig>('UTM_CONFIG');
